
export async function workTimeConversion(duration) {
  duration = duration.toFixed(2);
  if (duration >= 60) {
    var totalHour = Math.floor(duration / 60);
    var totalMin = Math.floor(duration % 60);
    return totalHour + "h " + totalMin + "m";
  } else if (duration >= 1 && duration < 60) {
    var totalMin = Math.floor(duration);
    var totalSec = duration - totalMin;
    totalSec = Math.floor(totalSec * 60);
    return totalMin + "m " + totalSec + "s";
  } else {
    var totalSec = Math.floor(duration * 60);
    return totalSec + "s";
  }
}

export const calculateTotalHour = (workLogHistoryData) => {
  let totalSeconds = 0;
  if(workLogHistoryData?.length == 0) return `0s`;
  for (let i = 0; i < workLogHistoryData.length; i++) {
    const duration = Number(workLogHistoryData[i]?.totalDuration || 0);
    totalSeconds += Math.floor(duration * 60); // minutes → seconds
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
}


export function getHours(totalDuration) {
  if (totalDuration) {
    return (totalDuration / 60);
  } else {
    return 0;
  }
}